import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=0c734031&scoped=true"
import script from "./ReadMore.vue?vue&type=script&lang=js"
export * from "./ReadMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c734031",
  null
  
)

export default component.exports